





































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { SweetModal } from 'sweet-modal-vue'

@Component({
  components: {
    SweetModal
  }
})
export default class ResultModal extends Vue {
  @Prop() private normalNumber!: number
  @Prop() private organicNumber!: number

  mounted() {
    ;(this.$refs.result_modal as any).open() // eslint-disable-line no-alert
  }

  get normalResultText() {
    return this.normalNumber < 10
      ? 'Die Hühner müssen noch deutlich mehr zusammenrücken.'
      : this.normalNumber < 26
      ? 'Die Hühner müssen noch ein bisschen mehr zusammenrücken.'
      : this.normalNumber === 26
      ? 'Genau richtig getippt!'
      : this.normalNumber > 26
      ? 'Ein bisschen mehr Platz haben die Hühner schon.'
      : ''
  }

  get organicResultText() {
    return this.organicNumber === 9
      ? 'Es darf 1 Huhn mehr sein.'
      : this.organicNumber < 10
      ? 'Es dürfen ein paar mehr sein.'
      : this.organicNumber === 10
      ? 'Genau richtig!'
      : this.organicNumber > 10
      ? 'Tatsächlich sind es weniger.'
      : ''
  }

  handleButtonClick() {
    ;(this.$refs.result_modal as any).close() // eslint-disable-line no-alert
  }

  handleModalClose() {
    this.$emit('modal-closed')
  }

  restartGame() {
    this.handleButtonClick()
    this.$emit('restart-game')
  }
}
